export const PENDING_REFERRAL_CODE_STORAGE_KEY = 'pendingReferralCode';

const normalizeReferralCode = (referralCode: string): string => referralCode.trim().toLowerCase();

export const savePendingReferralCode = (referralCode: string) => {
  localStorage.setItem(PENDING_REFERRAL_CODE_STORAGE_KEY, normalizeReferralCode(referralCode));
};

export const getPendingReferralCode = (): string | null =>
  localStorage.getItem(PENDING_REFERRAL_CODE_STORAGE_KEY)?.toLowerCase() ?? null;

export const clearPendingReferralCode = () => {
  localStorage.removeItem(PENDING_REFERRAL_CODE_STORAGE_KEY);
};
